<template>
  <draggable
    v-model="listProxy"
    class="level-two-list d-flex flex-column"
    item-key="id"
    handle=".drag-handle"
    :group="{ name: 'level2', pull: true, put: ['level2'] }"
    :animation="150"
  >
    <div v-for="(l2, index) in listProxy" :key="l2.id" class="level-two-wrap">
      <div
        class="level-two-item"
        :class="{ 'level-two-item--expanded': l2.expanded }"
      >
        <wizard-drag-zone :padding-top="0" />
        <div class="level-two-content d-flex flex-column">
          <wizard-row
            :value="l2.name"
            :placeholder="placeholders.level2"
            size="small"
            :is-expanded="l2.expanded"
            :can-show-delete="listProxy.length > 1"
            :has-validation-error="hasValidationError(2, index)"
            :on-delete="() => onDelete(index)"
            :on-duplicate="() => onDuplicate(index)"
            :on-toggle="l2.canNotExpand ? null : () => onToggle(index)"
            @update:value="onRename(index, $event)"
          />

          <div v-if="!l2.canNotExpand && l2.expanded" class="assignments">
            <div
              class="section-header d-flex align-items-center justify-content-between"
            >
              <h5 class="section-title">{{ $t("common.assignments") }}</h5>
              <eg-button
                type="ordinary"
                size="small"
                icon="plus-add-more-maximize"
                @click="onAddAssignment(index)"
                >{{ $t("common.addAssignment") }}</eg-button
              >
            </div>
            <assignment-list
              v-model="l2.children"
              :placeholders="placeholders"
              :has-validation-error="
                (level, l3Index) => hasValidationError(level, index, l3Index)
              "
            />
          </div>
        </div>
      </div>
    </div>
  </draggable>
</template>

<script>
import WizardDragZone from "./WizardDragZone.vue";
import WizardRow from "./WizardRow.vue";
import AssignmentList from "./AssignmentList.vue";
import draggable from "vuedraggable";

export default {
  name: "LevelTwoList",
  components: {
    WizardDragZone,
    WizardRow,
    AssignmentList,
    draggable,
  },
  props: {
    value: { type: Array, required: true, default: () => [] },
    labels: { type: Object, required: true },
    placeholders: { type: Object, required: true },
    hasValidationError: { type: Function, default: () => false },
  },
  computed: {
    listProxy: {
      get() {
        return this.value || [];
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    onRename(index, name) {
      const next = [...this.value];
      next[index] = { ...next[index], name };
      this.$emit("input", next);
    },
    onToggle(index) {
      const next = [...this.value];
      next[index] = { ...next[index], expanded: !next[index].expanded };
      this.$emit("input", next);
    },
    onDelete(index) {
      const next = this.value.slice();
      next.splice(index, 1);
      this.$emit("input", next);
    },
    onDuplicate(index) {
      const next = [...this.value];
      const original = next[index];
      const duplicate = JSON.parse(JSON.stringify(original));
      duplicate.id = Date.now() + Math.floor(Math.random() * 1000);
      duplicate.name = `${original.name}`;
      if (Array.isArray(duplicate.children)) {
        duplicate.children = duplicate.children.map((a) => ({
          ...a,
          id: Date.now() + Math.floor(Math.random() * 1000),
        }));
      }
      next.splice(index + 1, 0, duplicate);
      this.$emit("input", next);
    },
    onAddAssignment(index) {
      const next = [...this.value];
      const item = next[index];
      item.children = Array.isArray(item.children) ? item.children.slice() : [];
      item.children.push({
        id: Date.now(),
        name: "",
      });
      this.$emit("input", next);
    },
  },
};
</script>

<style scoped>
.level-two-list {
  gap: 12px;
}
.level-two-item {
  display: grid;
  grid-template-columns: 24px 1fr;
  background: var(--color-surface-neutral-container-1, #f6f8fb);
  border: 1px solid var(--color-stroke-neutral-subtle, #e6e8eb);
  border-radius: 16px;
  padding: 16px;
}
.level-two-item--expanded {
  border-color: var(--color-stroke-neutral-default, #dde1e6);
}

.level-two-content {
  gap: 8px;
}

.section-header {
  margin: 6px 0;
}
.section-title {
  margin: 0;
  font-weight: 500;
  font-size: 14px;
}
</style>
